import React from 'react'
import { Input } from '../Input'

/**
 * @desc Custom checkbox input.
 */
export const Checkbox = (props = {}) => {

  props.inputProps.type = 'checkbox'

  return (
    <Input {...props} />
  )
}
